export default {
	section_banner: {
		title: {
			one: 'Pay',
			two: 'With',
			three: 'One Tether',
		},
		subtitle: {
			one: 'Fast &',
			two: 'Secure ',
			three: 'Payments',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},
	section_question: {
		label: 'Question & Answer',
		title: {
			one: 'Anytime',
			two: 'Secure',
			three: 'Payments',
		},
		description:
			"JPWorldPay's security is the best in the world. We keep your cryptocurrency and digital assets completely safe and help you use them safely.",
		cta_button: 'Get Started',
	},
	section_we_offer: {
		label: 'JPWorldPay Wallet',
		title: {
			one: 'Enjoy',
			two: 'Shopping',
			three: 'Anywhere',
		},
		description:
			"With cryptocurrency stored in your JPWorldPay wallet, you can make seamless, secure transactions anytime and anywhere. Whether you're shopping online or paying at a physical store, JPWorldPay ensures fast and reliable payments powered by blockchain technology.",
		enjoy_shopping: {
			title: 'Enjoy Shopping Anywhere',
			subtitle: 'With cryptocurrency stored in your JPWorldPay wallet',
			boxes: {
				one: {
					title: 'Ideal Crypto Wallet',
					description:
						'Make a cryptocurrency wallet that you want in JPWorldPay.',
				},
				two: {
					title: 'Shop Smarter',
					description: 'Please choose JPWorldPay when you are shopping.',
				},
				three: {
					title: 'Pay With Us',
					description: 'Pay with the cryptocurrency you want on JPWorldPay.',
				},
			},
			cta_button: 'Create A Free Account',
		},
	},
	section_online_mid: {
		label: 'Fastest Payment System',
		title: {
			one: 'We Hope You',
			two: 'Enjoy',
			three: 'It Again',
		},
		description:
			'When you buy with JPWorldPay, you earn points for future purchases. JPWorldPay points are accepted at all merchants who use JPWorldPay, making it easy and rewarding to shop and save. Enjoy seamless transactions and unlock great savings with every purchase. Plus, enjoy exclusive offers and discounts available only to JPWorldPay users.',
		cta_button: 'Get Started',
	},
	section_growth: {
		stats: {
			total_customers: {
				value: '800k',
				label: 'Total Customers',
			},
			customer_satisfaction: {
				value: '99.90%',
				label: 'Customers Satisfaction',
			},
			money_managed: {
				value: '260b',
				label: 'Money Managed',
			},
		},
	},
	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
